import { useTranslation } from "react-i18next";

const gdprLinks = {
  de: "https://www.myclimate.org/de-ch/datenschutz/",
  en: "https://www.myclimate.org/en/data-privacy/",
  fr: "https://www.myclimate.org/fr-ch/politique-de-confidentialite/",
  it: "https://www.myclimate.org/it-ch/protezione-dei-dati/",
};

const getGdprLink = (language: string) => {
  if (language in gdprLinks) {
    return gdprLinks[language as keyof typeof gdprLinks];
  }
  return gdprLinks.de;
};

export const Footer: React.FC = () => {
  const { t, i18n } = useTranslation("footerComponent");

  const currentLanguage = i18n.language;

  return (
    <footer className="mt-5">
      <div className="container-fluid">
        <div className="d-flex flex-row-reverse">
          <ul className="nav topicsNav mb-5">
            <li className="nav-item">
              <a
                href={getGdprLink(currentLanguage)}
                title={t("GDPR")}
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link">
                {t("GDPR")}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
